// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-container {
    display: flex;
    flex-direction: column;
    max-width: 900px;
    border: 1px solid var(--border);
    padding: 20px;
    border-radius: 5px;
}

.header-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.update-info,
.client-info,
.payment-method,
.risk-assessment,
.overtime-data {
    width: 20%;
}

.avatar {
    width: 40px;
    height: 40px;
    background-color: #b5b5b5;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    color: white;
}

.client-info {
    display: flex;
    align-items: center;
}

.details-section {
    border-top: 1px solid var(--border);
    padding-top: 20px;
}

.details-section p {
    margin-bottom: 10px;
}

.withdrawDepositById_header{
    display: flex;
    justify-content: start;
    gap: 20px;
    align-items: center;
    margin-bottom: 20px;
}

.withdrawDepositById_header_profilPic{
    width: 80px;
    height: 80px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 200px;
}

.withdrawDepositById_header_name{
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.withdrawDepositById_header_name h3{
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}

.withdrawDepositById_header_name span{
    margin: 0;
    font-size: 23px;
    font-weight: bold;
}

.withdrawDepositById_items{
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 25px;
    width: max-content;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 0 25px;
    border-radius: 12px;
}

.withdrawDepositById_items hr{
    margin: 0;
    border: solid 0.5px var(--border);
}

.withdrawDepositById_item_box{
    display: flex;
    flex-direction: column;
    padding: 25px 0;
}

.withdrawDepositById_item_title{
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 5px;
}

.withdrawDepositById_item_content{
    font-size: 16px;
    font-weight: 400;
    color: var(--text-primary);
}

.withdrawDeposit_box{
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.withdrawDepositById_details {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.withdrawDepositById_details_wallet {
    width: 65%;
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 20px;
    border-radius: 15px;
}

.withdrawDepositById_details_wallet_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.withdrawDepositById_details_title {
    margin: 0 0 20px 0;
    font-size: 22px;
    font-weight: bold;
}

.withdrawDepositById_details_box{
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.withdrawDepositById_details_p {
    margin: 5px 0;
}

.withdrawDepositById_details_item_title {
    margin: 0;
    font-size: 11px;
    display: block;
    color: var(--text-muted);
}

.withdrawDepositById_details_item_desc{
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/Transactions/WithdrawDeposit/depositById/depositById.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;;;;IAKI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC","sourcesContent":[".payment-container {\n    display: flex;\n    flex-direction: column;\n    max-width: 900px;\n    border: 1px solid var(--border);\n    padding: 20px;\n    border-radius: 5px;\n}\n\n.header-section {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.update-info,\n.client-info,\n.payment-method,\n.risk-assessment,\n.overtime-data {\n    width: 20%;\n}\n\n.avatar {\n    width: 40px;\n    height: 40px;\n    background-color: #b5b5b5;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 10px;\n    color: white;\n}\n\n.client-info {\n    display: flex;\n    align-items: center;\n}\n\n.details-section {\n    border-top: 1px solid var(--border);\n    padding-top: 20px;\n}\n\n.details-section p {\n    margin-bottom: 10px;\n}\n\n.withdrawDepositById_header{\n    display: flex;\n    justify-content: start;\n    gap: 20px;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.withdrawDepositById_header_profilPic{\n    width: 80px;\n    height: 80px;\n    background-size: cover;\n    background-position: center center;\n    background-repeat: no-repeat;\n    border-radius: 200px;\n}\n\n.withdrawDepositById_header_name{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.withdrawDepositById_header_name h3{\n    margin: 0;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.withdrawDepositById_header_name span{\n    margin: 0;\n    font-size: 23px;\n    font-weight: bold;\n}\n\n.withdrawDepositById_items{\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    gap: 25px;\n    width: max-content;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 0 25px;\n    border-radius: 12px;\n}\n\n.withdrawDepositById_items hr{\n    margin: 0;\n    border: solid 0.5px var(--border);\n}\n\n.withdrawDepositById_item_box{\n    display: flex;\n    flex-direction: column;\n    padding: 25px 0;\n}\n\n.withdrawDepositById_item_title{\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 5px;\n}\n\n.withdrawDepositById_item_content{\n    font-size: 16px;\n    font-weight: 400;\n    color: var(--text-primary);\n}\n\n.withdrawDeposit_box{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.withdrawDepositById_details {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.withdrawDepositById_details_wallet {\n    width: 65%;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 20px;\n    border-radius: 15px;\n}\n\n.withdrawDepositById_details_wallet_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.withdrawDepositById_details_title {\n    margin: 0 0 20px 0;\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.withdrawDepositById_details_box{\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.withdrawDepositById_details_p {\n    margin: 5px 0;\n}\n\n.withdrawDepositById_details_item_title {\n    margin: 0;\n    font-size: 11px;\n    display: block;\n    color: var(--text-muted);\n}\n\n.withdrawDepositById_details_item_desc{\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
